const API_URL = process.env.REACT_APP_API_URL || "http://distribucion.hojaporhoja.com.ar/api.php";

let authToken = sessionStorage.getItem("eh_token") || "";
let onUnauthorized = null;

export function setAuthToken(token) {
  authToken = token || "";
  if (authToken) {
    sessionStorage.setItem("eh_token", authToken);
  } else {
    sessionStorage.removeItem("eh_token");
  }
}

export function setUnauthorizedHandler(handler) {
  onUnauthorized = typeof handler === "function" ? handler : null;
}

export async function fetchAPI(action, method = "GET", body = null, id = null) {
  let url = `${API_URL}?action=${encodeURIComponent(action)}`;
  if (id !== null && id !== undefined && id !== "") {
    url += `&id=${encodeURIComponent(id)}`;
  }

  const options = { method, headers: {} };
  if (authToken) {
    options.headers.Authorization = `Bearer ${authToken}`;
  }
  if (body) {
    options.headers["Content-Type"] = "application/json";
    options.body = JSON.stringify(body);
  }

  const response = await fetch(url, options);
  const text = await response.text();

  let payload = null;
  try {
    payload = text ? JSON.parse(text) : null;
  } catch (e) {
    throw new Error(`Respuesta JSON inválida para ${action}`);
  }

  if (!response.ok) {
    const message = payload?.message || payload?.error || `Error HTTP ${response.status}`;
    if (response.status === 401 && onUnauthorized) {
      onUnauthorized();
    }
    throw new Error(message);
  }

  return payload;
}
